module.exports = __webpack_public_path__ + "img/uni.cbe55c84.png";